import * as yup from "yup";

/* 
Required Fields : 
-= Payee Data Entry =-
Invoice Number 
Sold To
Tin
Address
-= Transaction Required Fields =-
VATable Sales
Zero Rated Sales
VAT-Exempt Sales

*/

export const invoiceSchema = yup.object({
  invoice_number: yup
    .string()
    .required("Invoice number is required"),

  soldTo: yup.string().required("Sold to (customer name) is required"),

  tin: yup
    .string()
    .required("TIN is required"),

  address: yup.string().required("Address is required"),

  vatableSalesRaw: yup
    .number()
    .required("VATable Sales is required")
    .min(0, "Cannot be negative"),

  zeroRatedSales: yup
    .number()
    .required("Zero Rated Sales is required")
    .min(0, "Cannot be negative"),

  vatExemptSales: yup
    .number()
    .required("Vat-Exempt Sales is required")
    .min(0, "Cannot be negative"),

  invoice_date: yup
    .date()
    .typeError("Invalid date format")
    .required("Invoice date is required"),

  invoice_items: yup
    .array()
    .of(
      yup.object({
        description: yup.string().required("Description is required"),
        quantity: yup.number().min(0, "Cannot be negative"),
        cost: yup.number().min(0, "Cannot be negative"),
      })
    )
    .min(1, "At least one invoice item is required")
    .required("Atleast One Invoice items are required"),
});
